//
import React, { useState, useEffect, lazy, Suspense } from "react";
import "./App.css";
import axios from "axios";
import CacheBuster from 'react-cache-buster';
import appversion from '../package.json';
import Loader from "./components/Loader";
import MediaQuery from "react-responsive";
import { CookieSetting } from "cookiesetting-component";
import jsonData from "./components/ai-branding.json"; // Import the JSON file

const Body = lazy(() => import("./components/Body/Body"));
const BodyMobile = lazy(() => import("./components/Body/Bodymobile"));
const LogoMobile = lazy(() =>
  import("./components/Logo Section/Logomobile.js")
);
const Logo = lazy(() => import("./components/Logo Section/Logo.js"));
const Footer = lazy(() => import("./components/Footer/Footer"));
const SignUpForm = lazy(() =>
  import("./components/ContactUS/SignUpForm.js")
);
const Video = lazy(() => import("./components/video.js"));
const PostEventMemories = lazy(() =>
  import("./components/PostEventMemories/PostEventMemories.js")
);
const Thankyou = lazy(() =>
  import("./components/ThankYou/Thankyou.js")
);
const SubscribeForEventNotifications = lazy(() =>
  import(
    "./components/SubscribeNotification/SubscribeForEventNotifications.js"
  )
);
const VideoHighlights = lazy(() =>
  import("./components/VideoHighlights/VideoHighlights.js")
);
const MemoriesHighlights = lazy(() =>
  import("./components/MemoryHighlight/MemoriesHighlight.js")
);
const PostSocial = lazy(() =>
  import("./components/PostSocial/PostSocial.js")
);
const PostEventVideo = lazy(() =>
  import("./components/PostEventVideos/PostEventVideos.js")
);

function App() {
const appVersion = appversion.version;
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const imgCDNURL = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;

  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };
    const [links, setLinks] = useState(null);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <div className="bodyContainer">
     <CacheBuster
      currentVersion={appVersion}
      isEnabled ={true}
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'}
    >
      <MediaQuery minWidth={992}>
        <Suspense fallback={<div />}>
          <Body links={links} handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
      </MediaQuery>
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <BodyMobile links={links} handleVideo={handleVideo} videoToggle={videoToggle} />
        </Suspense>
      </MediaQuery>
    
        <Suspense fallback={<div />}>
          <Logo />
        </Suspense>
      {/* </MediaQuery>
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <LogoMobile />
        </Suspense>
      </MediaQuery> */}
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <SignUpForm />
        </Suspense>
      </MediaQuery>
      {/* <Suspense fallback={<div />}> 
        <PostEventVideo handleVideo={handleVideo} videoToggle={videoToggle} />
      </Suspense>
      <Suspense fallback={<div />}>
      <PostEventMemories />    
      </Suspense>     
      <Suspense fallback={<div />}>
      <PostSocial handleVideo={handleVideo} videoToggle={videoToggle} />    
      </Suspense>      */}
      <Suspense fallback={<div />}>
        <Thankyou links={links}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense>
      <Suspense fallback={<div />}>
        <VideoHighlights />
      </Suspense>
      <Suspense fallback={<div />}>
        <MemoriesHighlights links={links}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      <Suspense fallback={<Loader />}>
        {played && (
          <Video handleVideo={handleVideo} videoToggle={videoToggle} />
        )}
      </Suspense>
      </CacheBuster>
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    </div>
  );
}

export default App;
